var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zm5.512 11.715c.114 0 .226-.006.336-.017V9.427a3.645 3.645 0 01-3.362-3.251h-1.957l-.02 9.53c0 1.169-1.035 2.09-2.206 2.09a2.118 2.118 0 01-2.12-2.117c0-1.17.949-2.117 2.12-2.117.065 0 .128.01.191.018l.066.008v-2.043a2.766 2.766 0 00-.257-.013 4.151 4.151 0 00-4.155 4.147c0 2.29 1.86 4.147 4.155 4.147a4.151 4.151 0 004.155-4.147v-5.611a3.652 3.652 0 003.054 1.647z"
  })));
};
export default SvgTiktok;